import React from 'react';

interface Props {
  label: string;
  active?: boolean;
  disabled?: boolean;
  visible?: boolean;
  onClick: () => void;
}

const SidebarSubItem = ({ label, active, disabled, visible, onClick }: Props) => {
  if (visible === false) {
    return null;
  }

  return (
    <button
      className={`
        sidebar-subitem 
        ${active ? 'sidebar-subitem-active' : ''}
        ${disabled ? 'sidebar-subitem-disabled' : ''}
      `}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default SidebarSubItem;
